import { Button } from "primereact/button";
import { useAuth } from "../auth/AuthProvider";
import { PiChargingStationFill } from "react-icons/pi";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDate } from "../utils/Dates";
import { FcFlashOn } from "react-icons/fc";
import Balance from "../components/Balance";
import { HeaderType } from "../components/Title";
import { MenuItem } from "../components/Menu";
import * as API from '../services/API';
import { EstacaoType, ConectorType } from "./Station";
import { CardEstacao, CardEstacaoVertical } from "../components/Card";
import { BsFillPlugFill } from "react-icons/bs";
import { BsLightningChargeFill } from "react-icons/bs";
import { BiSolidHandUp } from "react-icons/bi";
import { MdOutlineSwipeUp } from "react-icons/md";
import { IoMdArrowRoundUp } from "react-icons/io";

type Props = {
    balance: string
    chargeState: number
    setChargeState: Function
    setIndex: Function
    stations: EstacaoType[]
    station: EstacaoType | null
    setStation: Function
    conector: ConectorType | null
    setConector: Function
    loadingStatus: boolean
}
export const ChargeHeader = (): HeaderType => {
    return {
        title: 'Recarga',
        subtitle: `Olá ${useAuth().profile?.nome?.split(' ')[0]}`,
        icon: <BsLightningChargeFill size={40} />
    }
}
export const ChargerMenu = (): MenuItem => {
    return {
        icon: <BsLightningChargeFill size={32} />,
        label: 'RECARGA'
    }
}
// export const ChargerMenu = () => {
//     return (
//         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <PiChargingStationFill size={32} />
//             <div style={{ fontSize: 10, marginTop: 5 }}>
//                 RECARGA
//             </div>
//         </div>
//     )
// }

const Charge = (props: Props) => {
    const authenticator = useAuth()

    // const [state, setState] = useState(0)
    //-1: Rejected
    //0: Button
    //1: Peding
    //2: Connecting
    //3: Charging

    const [transaction, setTransaction] = useState<any>()
    const play = async () => {
        if (!props.station || !props.conector) return;
        props.setChargeState(1) //criar outro estado para identificar se acatou o comando ou nao
        try {
            const response = await fetch(`https://api.eletroposto.gearspark.com.br/api/start/`, { headers: { 'Authorization': `Bearer ${authenticator.token}` } })
            if (response.ok) {

                const data = await response.json()
                console.log('Response of Start', data)
                if (data.message.status === "Accepted")
                    props.setChargeState(2)
                else
                    props.setChargeState(-1)
            }
        } catch (error) {
            console.error('Error on get saldo', error)
            throw error;
        }
        // if (props.station && props.conector){
        //     const token = await API.getTokenStation(props.station)
        //     console.log('Token of Station', token)
        //     const response = await API.startCharging(props.conector, token)
        //     console.log('Response of Start', response)
        //     if (response.ok)
        //         props.setChargeState(2)
        //     else
        //         props.setChargeState(-1)
        // }
        // if (props.conector) {
        //     props.setChargeState(1)
        //     const recarga = await API.postRecargas(authenticator.token, 35, props.conector)
        //     console.log('Recarga', recarga)
        //     console.log(('' + recarga.non_field_errors[0]).indexOf('Saldo insuficiente.') > -1)

        //     if (recarga.non_field_errors === undefined)
        //         props.setChargeState(2)
        //     else if (('' + recarga.non_field_errors[0]).indexOf('Saldo insuficiente.') > -1)
        //         props.setChargeState(-2)
        //     else
        //         props.setChargeState(-1)
        // }
    }
    const getCurrentTransaction = async () => {
        const response = await fetch(`https://api.eletroposto.gearspark.com.br/api/current-transaction/`, { headers: { 'Authorization': `Bearer ${authenticator.token}` } })
        const data = await response.json()
        console.log('Response of Get Current Transaction', data)
        return data

    }
    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;
        let timeout: NodeJS.Timeout | null = null;
        if (props.chargeState === 2) {
            interval = setInterval(async () => {
                const response = await getCurrentTransaction();
                console.log('Response of Current Transaction', response.transaction)
                setTransaction(response.transaction)
                if (response.transaction !== null) {
                    // Para o intervalo se a resposta for true
                    if (interval) clearInterval(interval);
                    props.setChargeState(3)
                }
            }, 5000); // Executa a cada 5 segundos
            timeout = setTimeout(() => {
                if (interval) clearInterval(interval); // Para o intervalo após 1 minuto
            }, 60000); // 1 minuto em milissegundos
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [props.chargeState])
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: -4, alignItems: 'center' }}>
                    <div style={{ marginRight: 3 }}>
                        Estação
                    </div>
                    <PiChargingStationFill size={20} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, marginBottom: 5, paddingTop: 5, paddingBottom: 5, width: '100%', backgroundColor: 'lightgray', borderRadius: 10 }} >
                    {props.stations.map(s => {
                        return (<Button style={{ marginRight: 10, padding: 5, width: 140, height: 50, display: 'flex', justifyContent: 'center' }} disabled={(s.status !== 'LIVRE' && s.status !== 'ONLINE')} severity={props.station?.id === s.id ? undefined : 'secondary'} onClick={() => props.setStation(s)}>
                            <CardEstacaoVertical estacao={s} loadingStatus={props.loadingStatus} dark />
                        </Button>
                        )
                    }
                    )}
                    {/* <Button onClick={() => props.setIndex(1)}>
                        {
                            props.station ?
                                <CardEstacao estacao={props.station} loadingStatus={false} dark/> 
                                :
                                <div>Clique aqui para selecionar<br />uma estaçao de carregamento</div>
                        }
                    </Button> */}
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: -4, alignItems: 'center' }}>
                    <div style={{ marginRight: 3 }}>
                        Tomada
                    </div>
                    <PiChargingStationFill size={20} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, marginBottom: 5, paddingTop: 5, paddingBottom: 5, width: '100%', backgroundColor: 'lightgray', borderRadius: 10 }}>
                    {
                        props.station ?
                            props.station.conectores.map((plug: any, index: number) => (
                                <Button key={plug.id} style={{ marginRight: 10, width: 140, height: 50 }} onClick={() => props.setConector(plug)} severity={props.conector?.id === plug.id ? undefined : 'secondary'}
                                // disabled={props.chargeState > 1 || (plug.status !== 'LIVRE' && plug.status !== 'ONLINE')}
                                >
                                    <BsFillPlugFill size={32} style={{ marginBottom: -3 }} />
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', }}>
                                        <div>
                                            {plug.plugue.nome}
                                        </div>
                                        <div style={{ fontSize: 10, marginTop: -3 }}>
                                            Conector {index + 1}
                                        </div>
                                    </div>
                                </Button>
                            ))
                            :
                            <div style={{ display: 'flex', alignItems: 'center' }}>Selecione uma estação<IoMdArrowRoundUp style={{ marginLeft: 5 }} /></div>

                    }
                </div>
            </div>

            <Balance balance={props.balance} />

            <Button onClick={play} severity={props.chargeState < 1 ? undefined : 'secondary'} disabled={props.chargeState > 1}>

                {props.chargeState < 1 &&
                    < div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        {/* <BsFillLightningFill size={32} /> */}
                        <FcFlashOn size={32} />
                        <div style={{ fontFamily: 'Verdana', fontSize: 24 }}>CARREGAR</div>
                    </div>
                }{
                    props.chargeState === 1 &&
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        <ProgressSpinner style={{ width: 32, height: 32 }} />
                    </div>
                }{
                    props.chargeState === 2 &&
                    <>
                        CONECTE O CABO
                    </>
                }{
                    props.chargeState === 3 &&
                    <>
                        CHARGING
                    </>
                }

            </Button >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', width: '100%', fontSize: 12 }}>

                {
                    props.chargeState === -2 ?
                        <div style={{ color: 'red' }}>STATUS: Saldo insuficiente</div> :
                        props.chargeState === -1 ?
                            <div style={{ color: 'red' }}>STATUS: Não foi possível iniciar o carregamento!</div>
                            : props.chargeState === 1 ?
                                <>Iniciando Carregamento</>
                                : props.chargeState === 2 ?
                                    <>Conecte o plug elétrico</>
                                    : props.chargeState === 3 ?
                                        <>Carregando transação de numero {transaction?.id} iniciado em {formatDate(transaction?.dateStart)}</>
                                        :
                                        <></>
                }
            </div>
        </div >
    )
}
export default Charge;